export default "__VITE_ASSET__BRkif5o1__"